<template>
<div class="detail_body">
		<!-- <v-head
		title="抬头信息"
		:sdata="sdata"></v-head> -->
  <div class="coll">
    <h2 class="title"><span>生产订单明细</span></h2>
    <tab-list :tabList="sdata" :columns="tabColumns" setHeadBtn tabName="business-sale-detail" tabHeight="500">
    </tab-list>
  </div>
</div>
</template>

<script>
import tabList from 'components/table/list.vue';
export default{
  props:{
    sdata:Array
  },
	components:{
		tabList
	},
	data(){
		return{
      tabColumns:[
        {field: 'requirementCode', title: '预留编号',width: 100,"sortable":true},
        {field: 'materialCode', title: '物料编码'},
        {field: 'materialDesc', title: '物料描述'},
        {field: 'basicUnitDesc', title: '计量单位'},
        {field: 'inventoryCode', title: '库存地编码'},
        {field: 'inventoryDesc', title: '库存地描述'},
        {field: 'demandQuantity', title: '需求数量'},
        {field: 'requireQuantity', title: '需求量'},
        {field: 'orderQuantity', title: '出库数量'},

      ],//表头字段
		}
	},
	created(){

	},
	methods:{
	}
}
</script>

<style>
</style>
